export default __webpack_public_path__ + "static/media/maintanance.9cc52f3e.webp";